import script from "./SocialMediaLinksSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialMediaLinksSection.vue?vue&type=script&setup=true&lang=js"

import "./SocialMediaLinksSection.vue?vue&type=style&index=0&id=f8180556&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8180556"]])

export default __exports__